import React, { useEffect, useState } from "react";
import ChatSection from "./ChatSection/ChatSection";
import ParticipantsSection from "./ParticipantsSection/ParticipantsSection";
import VideoSection from "./VideoSection/VideoSection";
import { connect } from "react-redux";
import * as webRTCHandler from "../utils/webRTCHandler";
import Overlay from "./Overlay";
// import ErrorPopup from "../Popup/ErrorPopup";
import "./RoomPage.css";
import Timer from "./Timer";
import { setMeetEnd } from "../store/actions";
const RoomPage = ({
  roomId,
  identity,
  isRoomHost,
  showOverlay2,
  connectOnlyWithAudio,
  valid,
  showChat,
  showParticipants,
  hostId,
  shareBtn,
  mikeInfo,
  participants,
  meetEnd,
  setMeetEndAction,
  userId
}) => {

const [meetingEnd,setMeetingEnd]= useState(false);
const [sideToggle,setSideToggle]= useState(false)

console.log("showParticipants2223322",participants.length, meetingEnd)

 useEffect(()=>{

if(meetingEnd){
  setMeetEndAction(meetingEnd)
}

 },[meetingEnd])

  useEffect(() => {
    if (!isRoomHost && !roomId) {
      const siteUrl = window.location.origin;
      window.location.href = siteUrl;
    } else {
      webRTCHandler.GetLocalPreviewAndInitRoomConnection(
        isRoomHost,
        identity,
        roomId,
        connectOnlyWithAudio,
        hostId,
        userId
      );
      console.log(valid);
    }
    // eslint-disable-next-line
  }, []);
// useEffect(()=>{
//   if(!valid && !connectOnlyWithAudio){
//     setShow(true)
//   }
// },[valid,connectOnlyWithAudio])


window.addEventListener('popstate', function(){
  		window.location.reload()
  	}, false);
  


useEffect(()=>{
  let aj= document.querySelector(".shared");
  if(aj){
    if(shareBtn?.Buttons) aj?.classList.add("flipped");
    else{
      aj?.classList.remove("flipped")
    }
  }
 
   
},[shareBtn]);

useEffect(() => {
  let mutify = document.querySelector(".muteIndicator");
  if (mutify) {
    // if (mikeInfo)
    //   mutify.innerHTML = `<svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.85907 0.5C4.61907 0.5 3.60907 1.51 3.60907 2.75V6.5C3.60907 6.5525 3.61145 6.60478 3.61395 6.65479L3.98407 6.28516V6.28467L4.29657 5.97266L7.35907 2.91016V2.90967L7.72137 2.54736L8.04657 2.22266C7.80907 1.23516 6.91657 0.5 5.85907 0.5ZM10.4767 0.996582C10.3794 0.99942 10.2869 1.04005 10.2189 1.10986L0.96893 10.3599C0.932941 10.3944 0.904208 10.4358 0.884415 10.4816C0.864621 10.5274 0.854164 10.5767 0.853657 10.6266C0.85315 10.6765 0.862602 10.726 0.881461 10.7721C0.900319 10.8183 0.928204 10.8603 0.963484 10.8956C0.998763 10.9309 1.04073 10.9587 1.08692 10.9776C1.13311 10.9965 1.1826 11.0059 1.23249 11.0054C1.28238 11.0049 1.33166 10.9944 1.37746 10.9747C1.42326 10.9549 1.46465 10.9261 1.4992 10.8901L3.22577 9.16357C3.81927 9.75171 4.60797 10.1408 5.48407 10.2285V11.375C5.48336 11.4247 5.49255 11.474 5.51108 11.5201C5.52961 11.5663 5.55712 11.6082 5.59201 11.6436C5.6269 11.679 5.66848 11.7071 5.71432 11.7263C5.76017 11.7455 5.80937 11.7553 5.85907 11.7553C5.90876 11.7553 5.95797 11.7455 6.00381 11.7263C6.04966 11.7071 6.09124 11.679 6.12613 11.6436C6.16102 11.6082 6.18853 11.5663 6.20706 11.5201C6.22559 11.474 6.23477 11.4247 6.23407 11.375V10.231C8.12617 10.0421 9.60907 8.44092 9.60907 6.5V5.625C9.60907 5.4175 9.44157 5.25 9.23407 5.25C9.02657 5.25 8.85907 5.4175 8.85907 5.625V6.5C8.85907 8.14001 7.53786 9.4735 5.9035 9.49756C5.89928 9.497 5.89505 9.49651 5.89081 9.49609C5.87831 9.49498 5.86576 9.49449 5.85321 9.49463C5.84064 9.49481 5.82809 9.49563 5.81561 9.49707C5.81496 9.49723 5.81431 9.49739 5.81366 9.49756C5.81349 9.49756 5.81333 9.49756 5.81317 9.49756C5.01156 9.48535 4.28599 9.15846 3.75555 8.63379L4.28729 8.10205C4.69351 8.50069 5.24652 8.75 5.85907 8.75C7.09907 8.75 8.10907 7.74 8.10907 6.5V4.28027L10.7492 1.64014C10.8033 1.58745 10.8402 1.51965 10.8552 1.44563C10.8701 1.3716 10.8623 1.29479 10.8329 1.22525C10.8035 1.15571 10.7537 1.09667 10.6902 1.05587C10.6266 1.01507 10.5522 0.994408 10.4767 0.996582ZM2.48407 5.25C2.27657 5.25 2.10907 5.4175 2.10907 5.625V6.5C2.10907 6.9925 2.20415 7.46258 2.37665 7.89258L2.96893 7.2998C2.89643 7.0448 2.85907 6.7775 2.85907 6.5V5.625C2.85907 5.4175 2.69157 5.25 2.48407 5.25Z" fill="white"></path></svg>`;
    // else {
    //   mutify.innerHTML = `<svg width="11" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //   <path d="M12 16.25C9.38 16.25 7.25 14.12 7.25 11.5V6C7.25 3.38 9.38 1.25 12 1.25C14.62 1.25 16.75 3.38 16.75 6V11.5C16.75 14.12 14.62 16.25 12 16.25ZM12 2.75C10.21 2.75 8.75 4.21 8.75 6V11.5C8.75 13.29 10.21 14.75 12 14.75C13.79 14.75 15.25 13.29 15.25 11.5V6C15.25 4.21 13.79 2.75 12 2.75Z" fill="#404040"/>
    //   <path d="M12 19.7499C7.36998 19.7499 3.59998 15.9799 3.59998 11.3499V9.6499C3.59998 9.2399 3.93998 8.8999 4.34998 8.8999C4.75998 8.8999 5.09998 9.2399 5.09998 9.6499V11.3499C5.09998 15.1499 8.19998 18.2499 12 18.2499C15.8 18.2499 18.9 15.1499 18.9 11.3499V9.6499C18.9 9.2399 19.24 8.8999 19.65 8.8999C20.06 8.8999 20.4 9.2399 20.4 9.6499V11.3499C20.4 15.9799 16.63 19.7499 12 19.7499Z" fill="#404040"/>
    //   <path d="M13.39 7.18007C13.31 7.18007 13.22 7.17007 13.13 7.14007C12.4 6.87007 11.6 6.87007 10.87 7.14007C10.48 7.28007 10.05 7.08007 9.91 6.69007C9.77 6.30007 9.97 5.87007 10.36 5.73007C11.42 5.35007 12.59 5.35007 13.65 5.73007C14.04 5.87007 14.24 6.30007 14.1 6.69007C13.98 6.99007 13.69 7.18007 13.39 7.18007Z" fill="#404040"/>
    //   <path d="M12.8 9.30007C12.73 9.30007 12.67 9.29007 12.6 9.27007C12.2 9.16007 11.79 9.16007 11.39 9.27007C10.99 9.38007 10.58 9.14007 10.47 8.74007C10.36 8.35007 10.6 7.94007 11 7.83007C11.65 7.65007 12.35 7.65007 13 7.83007C13.4 7.94007 13.64 8.35007 13.53 8.75007C13.44 9.08007 13.13 9.30007 12.8 9.30007Z" fill="#404040"/>
    //   <path d="M12 22.75C11.59 22.75 11.25 22.41 11.25 22V19C11.25 18.59 11.59 18.25 12 18.25C12.41 18.25 12.75 18.59 12.75 19V22C12.75 22.41 12.41 22.75 12 22.75Z" fill="#404040"/>
    //   </svg>`;
    // }
    if (mikeInfo)
    // mutify.innerHTML = `<img src="../assets/icons/micIcon.svg" alt="" class="videoUsername" />`
        mutify.innerHTML = `<img src="../assets/icons/micUpper.svg" alt=""  />`;
  else {
    // mutify.innerHTML = `<img src="../assets/icons/mic on.svg" alt=""  />`;
    mutify.innerHTML = `<img src="../assets/icons/micIcon.svg" alt="" class="videoUsername" />`
  }
  }
}, [mikeInfo]);
 
  return (
    // <div className="room_container">
    //   { showParticipants && <ParticipantsSection />}
    //   <ErrorPopup isOpen={show}/>
    //   <VideoSection roomId={roomId}  />
    //   {showChat && <ChatSection />}
    //   {/* <RoomLabel roomId={roomId} /> */}
    //   {showOverlay && <Overlay />}
    // </div>
    <div className="meetingPageOuter">
      {showOverlay2 && <Overlay />}
            <div className="meetingPageContainer">
                <div className="meetingPageHeader">
                    <div className="headerContainer">
                        <img src="../assets/icons/main-logo.png" alt="" className='logo' />
                        { participants.length >1 && <Timer setMeetingEnd={setMeetingEnd}/>}
                        <button onClick={()=>setSideToggle(!sideToggle)} class="primary-btn" id="hb2"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        {/* <img src="https://mastersunion.org/assets/img/svg/Close.svg" class="menu-close"/> */}
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M2 4.66667C2 4.29848 2.29848 4 2.66667 4H17.3333C17.7015 4 18 4.29848 18 4.66667C18 5.03486 17.7015 5.33333 17.3333 5.33333H2.66667C2.29848 5.33333 2 5.03486 2 4.66667ZM2 10C2 9.63181 2.29848 9.33333 2.66667 9.33333H17.3333C17.7015 9.33333 18 9.63181 18 10C18 10.3682 17.7015 10.6667 17.3333 10.6667H2.66667C2.29848 10.6667 2 10.3682 2 10ZM2.66667 14.6667C2.29848 14.6667 2 14.9651 2 15.3333C2 15.7015 2.29848 16 2.66667 16H17.3333C17.7015 16 18 15.7015 18 15.3333C18 14.9651 17.7015 14.6667 17.3333 14.6667H2.66667Z" fill="#121112"></path>
                    </svg>
                </button>
                        {/* <div className="recording">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.97754 17.0625C4.53754 17.0625 0.915039 13.4475 0.915039 9C0.915039 4.5525 4.53754 0.9375 8.97754 0.9375C13.4175 0.9375 17.04 4.5525 17.04 9C17.04 13.4475 13.425 17.0625 8.97754 17.0625ZM8.97754 2.0625C5.15254 2.0625 2.04004 5.175 2.04004 9C2.04004 12.825 5.15254 15.9375 8.97754 15.9375C12.8025 15.9375 15.915 12.825 15.915 9C15.915 5.175 12.8025 2.0625 8.97754 2.0625Z" fill="#EF5350" />
                                <path d="M9.00014 12.735C6.93764 12.735 5.26514 11.0625 5.26514 9.00002C5.26514 6.93751 6.93764 5.26501 9.00014 5.26501C11.0626 5.26501 12.7351 6.93751 12.7351 9.00002C12.7351 11.0625 11.0626 12.735 9.00014 12.735ZM9.00014 6.39002C7.56014 6.39002 6.39014 7.56001 6.39014 9.00002C6.39014 10.44 7.56014 11.61 9.00014 11.61C10.4401 11.61 11.6101 10.44 11.6101 9.00002C11.6101 7.56001 10.4401 6.39002 9.00014 6.39002Z" fill="#EF5350" />
                            </svg>
                            <p className="time">01:03:34</p>
                            <p className='time'>{minutes<10?"0"+minutes:minutes}:{seconds<10 ? "0"+seconds: seconds}</p>
                        </div> */}
                      
                    </div>
                </div>
                 <div className="meetingVideoArea">
                  {/*  <div className="userVideo small">
                        <div className="userVideoHeader">
                            <img src="../assets/icons/micIcon.svg" alt="" className="videoUsername" />
                        </div>
                        <img
                            className="userVideoBox "
                            src="https://images.unsplash.com/photo-1568602471122-7832951cc4c5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80" alt="" />
                        <div className="userVideoFooter">
                            <p className="videoUsername">Diana</p>
                        </div>
                    </div>
                    <div className="userVideo">
                        <div className="userVideoHeader">
                            <img src="../assets/icons/micIcon.svg" alt="" className="videoUsername" />
                        </div>
                        <img
                            className="userVideoBox"
                            src="https://images.unsplash.com/photo-1568602471122-7832951cc4c5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80" alt="" />
                        <div className="userVideoFooter">
                            <p className="videoUsername">Diana</p>
                        </div>
                    </div>

                </div> */}
                </div>
                <VideoSection roomId={roomId}  />
            </div>
            <div className={sideToggle ?"chatBoxOuter active" :"chatBoxOuter"}>
              <ParticipantsSection />
                <ChatSection />
            </div>
        </div>
  );
};

const mapStoreStateToProps = (state) => {
  return {
    ...state,
  };
};

const mapActionsToProps = (dispatch) => {
  return {
    setMeetEndAction: (meetEnd) => dispatch(setMeetEnd(meetEnd)),
  };
};

export default connect(mapStoreStateToProps, mapActionsToProps)(RoomPage);
